module.exports = __webpack_public_path__ + "img/bg_night.a314ac88.jpg";